export function momijiMap() {
  const map = document.querySelector('.map-svg');
  if(map){
    const prefs = map.querySelectorAll('.prefecture')
    prefs.forEach((pref) => {
      pref.addEventListener('mouseover', () => {
        pref.classList.add('hover');
      })
      pref.addEventListener('mouseleave', () => {
        pref.classList.remove('hover');
      })
      pref.addEventListener('click', () => {
        const url = pref.dataset.url;
        if(url && pref.classList.contains('is-active')) {
          location.href = url
        }
      })
    })
  }
}